import React from "react";
import { motion } from "framer-motion";
import './Projects.css';

export default function Projects () {
    
        return (
            <div className="projects-container">
                <h1 className="projects-title">Projects</h1>
                <div className="projects">
                    <motion.div 
                        className="project"
                        whileHover={{scale: 1.1}} >
                        <h2 className="project-title">Project 1</h2>
                        <p className="project-text">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Sed euismod, nisl nec aliquam aliquam, nunc nisl aliquet 
                            nunc, eget aliquam nisl nisl sit amet lorem. 
                            Sed euismod, nisl nec aliquam aliquam, nunc nisl aliquet 
                            nunc, eget aliquam nisl nisl sit amet lorem.
                        </p>
                        <div className="project-buttons">
                            <a className="project-button">View Project</a>
                            <a className="project-button">View Code</a>
                        </div>
                    </motion.div>
                    <motion.div 
                        className="project"
                        whileHover={{scale: 1.1}} >
                        <h2 className="project-title">Project 2</h2>
                        <p className="project-text">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Sed euismod, nisl nec aliquam aliquam, nunc nisl aliquet 
                            nunc, eget aliquam nisl nisl sit amet lorem. 
                            Sed euismod, nisl nec aliquam aliquam, nunc nisl aliquet 
                            nunc, eget aliquam nisl nisl sit amet lorem.
                        </p>
                        <div className="project-buttons">
                            <a className="project-button">View Project</a>
                            <a className="project-button">View Code</a>
                        </div>
                    </motion.div>
                    <motion.div 
                        className="project"
                        whileHover={{scale: 1.1}} >
                        <h2 className="project-title">Project 3</h2>
                        <p className="project-text">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Sed euismod, nisl nec aliquam aliquam, nunc nisl aliquet 
                            nunc, eget aliquam nisl nisl sit amet lorem. 
                            Sed euismod, nisl nec aliquam aliquam, nunc nisl aliquet 
                            nunc, eget aliquam nisl nisl sit amet lorem.
                        </p>
                        <div className="project-buttons">
                            <a className="project-button">View Project</a>
                            <a className="project-button">View Code</a>
                        </div>
                    </motion.div>
                </div>
            </div>
        )
}